// @copyright  2026 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/receivables/sales-orders/archive',
        component: () =>
            import('@/pages/[organisation]/receivables/sales-orders/archive.vue'),
        name: 'accounts-receivable.sales-orders.search-archived-sales-orders',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.sales-order.search-archived-sales-orders',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/receivables/sales-orders/archive/[id].vue'),
                name: 'accounts-receivable.sales-orders.view-archived-sales-order',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales-order.retrieve-archived-sales-order',
                },
            },
        ],
    },

    {
        path: '/:organisation/receivables/sales-orders',
        component: () =>
            import('@/pages/[organisation]/receivables/sales-orders.vue'),
        name: 'accounts-receivable.sales-orders.search-sales-orders',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.sales-order.search-sales-orders',
        },

        children: [
            {
                path: 'create-sales-order',
                component: () =>
                    import('@/pages/[organisation]/receivables/sales-orders/create-sales-order.vue'),
                name: 'accounts-receivable.sales-orders.create-sales-order',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales-order.create-sales-order',
                },
            },
            {
                path: ':id/update-sales-order',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.sales-orders" */ '@/pages/[organisation]/receivables/sales-orders/sales-order/[id]/edit.vue'),
                name: 'accounts-receivable.sales-orders.update-sales-order',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales-order.update-sales-order',
                },
            },
            {
                path: ':id/convert-sales-order-to-invoice',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.sales-orders" */ '@/pages/[organisation]/receivables/sales-orders/convert-sales-order-to-invoice.vue'),
                name: 'accounts-receivable.sales-orders.convert-sales-order-to-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales-order.convert-to-invoice',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.sales-orders" */ '@/pages/[organisation]/receivables/sales-orders/sales-order/[id].vue'),
                name: 'accounts-receivable.sales-orders.view-sales-order',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales-order.view-sales-order',
                },
            },
            {
                path: ':id/history',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.sales-orders" */ '@/pages/[organisation]/receivables/sales-orders/sales-order-history.vue'),
                name: 'accounts-receivable.sales-orders.view-sales-order-history',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.sales-order.search-sales-order-histories',
                },
            },
        ],
    },
];
